// TODO. Use css modules to get the sass variables
// when we eject or upgrade to CRAv2

export default {
  /* Deprecated */
  spearmint60: '#229D9D',

  nephritis: '#27AE60',
  nephritis10: '#E9F6EF',
  nephritis20: '#D6F5E4',
  nephritis70: '#1B7F45',
  wisteria: '#8e44ad',
  wisteria10: '#eff0ff',
  eggYolk: '#e7b41a',
  eggYolk10: '#FAF0D1',
  eggYolk50: '#E7B41A',
  // Feedback Inbox "Needs response" amber (Sketch v83 `.ib-it-status.need`).
  // eggYolk50 fails AA as text on white; this is 4.9:1 on white, 4.65:1 on a
  // hovered row (grey05) and 4.44:1 on the selected row (grey10).
  eggYolk70: '#8A6D1A',
  // Past feedback strip text on eggYolk10, 5.3:1 (AA).
  eggYolk80: '#7A5F12',
  // Darkest egg-yolk tint: the text and icon colour of the warning note
  // that sits on an `eggYolk10` block (Order feedback settings). Same hue
  // as `eggYolk`, dropped to ~32% lightness so it reads on that tint.
  eggYolk90: '#8A6D1A',
  orange: '#f39c12',
  belizeHole: '#0073bf',
  belizeHole10: '#e5f0f8',
  grey05: '#F8F9FA',
  grey10: '#f2f4f5',
  grey20: '#e9eaec',
  grey30: '#d6dade',
  grey40: '#c2c8ce',
  grey50: '#a4adb6',
  grey: '#a4adb6',
  grey70: '#6a747f',
  grey90: '#36424e',
  spearmint05: '#FAFEFE',
  // The SCSS palette's `spearmint-05` (_palette.scss), a different tint from the
  // `spearmint05` above; both are in use, so they need distinct names here.
  spearmintTint: '#F1FBFB',
  spearmint10: '#E7F9F9',
  spearmint20: '#D0F3F2',
  spearmint30: '#89E0DF',
  spearmint50: '#13C1BF',
  spearmint50Hover: '#15D6D4',
  spearmint: '#13C1BF',
  // RecoveryAI teal (Sketch v83 wordmark / RAI email mail icon). 3.9:1 on
  // spearmint10 — icon/large-text contrast only, not body text.
  spearmint70: '#0E8A88',
  // Darkest RecoveryAI teal (Sketch v83 RAI copy colour). White text on it
  // is 7.4:1, where spearmint50/60 both fail AA.
  spearmint90: '#0C5F5D',
  cayenne05: '#fdecea',
  cayenne10: '#fbdfd6',
  cayenne50: '#f26335',
  cayenne: '#f26335',
  // Filled danger button states. White text is 4.8:1 on the fill, 5.3:1 on
  // hover and 5.6:1 pressed, where plain cayenne is only 3.2:1.
  cayenneFill: '#c9461a',
  cayenneHover: '#bf4012',
  cayenneActive: '#b83d16',
  // TUTD design-spec red — first red token, nearest existing is cayenne (orange).
  red50: '#FB2C36',
  // Fixed live-activity mock colors, not theme colors.
  phoneBezel: '#232c37',
  heroPhoneBezel: '#20262b',
  phoneSurface: '#20303b',
  phoneScreenEnd: '#123f45',
  phoneHeroTop: '#1f2b33',
  phoneHeroBottom: '#14454a',
  phoneHeroCard: '#14343d',
  phoneCutout: '#0a141a',
  phoneTextSubtle: '#c3cfd4',
  phoneTextMuted: '#9fb3ba',
  phoneRailLine: '#3a4a53',
  phoneRailDotOff: '#4a5a63',
  phoneRailDotOn: '#e3edf0',
  mockWashStart: '#eef8fb',
  mockWashEnd: '#dfeff0',
  mockWashHeroStart: '#eef4f6',
  mockAlert: '#eb5757',
  mockAlertText: '#b3494c',
  mockAlertWash: '#fdf0f0',
  mockBrandTile: '#c2502a',
  mockSuccess: '#3fa652',
  white: '#ffffff',
  black: '#000000',
}
